import { useTranslation } from 'react-i18next'
import {
  RouteProps,
  useHistory,
  useLocation,
  useRouteMatch,
} from 'react-router-dom'

import { SecureRoute } from '@okta/okta-react'
import { LoadingPage } from '@rfh-core/components'

import { useUserStore } from 'src/common/stores/UserStore'

import type { RenderProps } from './utils'

type AccountManagementRouteProps = RouteProps & { enabled?: boolean }

export default function AccountManagementRoute({
  component: Component,
  enabled = true,
  ...rest
}: Readonly<AccountManagementRouteProps>): JSX.Element {
  const { user } = useUserStore()
  const history = useHistory()
  const location = useLocation()
  const match = useRouteMatch()
  const { t } = useTranslation()

  const getContent = (props: RenderProps): JSX.Element => {
    if (!user.isAuthenticated) {
      return <LoadingPage label={t('common.loading')} />
    }

    // user is authenticated but the "enabled" prop is passed as "false"
    // => nothing to do
    if (enabled != null && !enabled) {
      return
    }

    // "enabled" prop is not passed at all or passed as "true"
    // => the Component may be shown
    if (!(user.isAccountManagement || user.isApplicationManager)) {
      console.warn(
        'Redirected unauthorized access to account manager only route'
      )
      history.push('/dashboard')
    } else {
      return (
        <Component
          history={history}
          location={location}
          match={match}
          {...props}
        />
      )
    }
  }

  return (
    <SecureRoute
      {...(rest as any)}
      render={(props: RenderProps) => getContent(props)}
    />
  )
}
